// public/v3/src/components/bhi-assessment-history-modal.jsx —
// read-only modal showing the full chronology of BHI rating-scale
// assessments for one patient. Triggered by the "History →" link in
// the Studio BHI section. iPad-sized matching BhiAssessmentModal.
// No unsaved-changes guard — modal is read-only.

import React from 'react';
import { computeSeverity } from '../lib/bhi-scales';

function formatDate(iso) {
  if (!iso) return '';
  // YYYY-MM-DD passthrough; tolerant of partial strings.
  return iso;
}

function lookupSeverity(scale, score) {
  try {
    const result = computeSeverity(scale, score, null);
    return result || null;
  } catch (_) {
    return null;
  }
}

export function BhiAssessmentHistoryModal({ patient, onClose }) {
  const raw = patient?._raw || patient || {};
  const entries = Array.isArray(raw.bhi?.assessments) ? raw.bhi.assessments : [];
  const sorted = entries.slice().sort((a, b) => (b.date || '').localeCompare(a.date || ''));
  const patientName = [raw.fname, raw.lname].filter(Boolean).join(' ') || patient?.name || 'Patient';

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal bhi-history-modal"
        role="dialog"
        aria-modal="true"
        aria-label={`BHI assessment history for ${patientName}`}
        onClick={(e) => e.stopPropagation()}>
        <header className="modal-header">
          <h2>BHI assessment history</h2>
          <div className="modal-subtitle">{patientName}</div>
          <button className="modal-close" onClick={onClose} aria-label="Close">✕</button>
        </header>
        <div className="modal-body">
          {sorted.length === 0 ? (
            <div className="bhi-history-empty">No assessments on file.</div>
          ) : (
            <ul className="bhi-history-list">
              {sorted.map((entry, i) => {
                const severity = entry.severity || lookupSeverity(entry.scale, entry.score);
                return (
                  <li key={i} className="bhi-history-entry">
                    <div className="bhi-history-date">{formatDate(entry.date)}</div>
                    <div className="bhi-history-scale">
                      <b>{entry.scale}</b> score {entry.score}
                      {severity ? <span className={`severity severity-${String(severity).toLowerCase().replace(/\s+/g, '-')}`}> ({severity})</span> : null}
                    </div>
                    {entry.notes ? <div className="bhi-history-notes">{entry.notes}</div> : null}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
        <footer className="modal-footer">
          <button className="btn primary" onClick={onClose}>Close</button>
        </footer>
      </div>
    </div>
  );
}
